var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 16C4.9265 16 4.8525 15.984 4.7835 15.9505C4.61 15.867 4.5 15.6925 4.5 15.5V12H1.2525C0.562 12 0 11.438 0 10.7475V1.2525C0 0.562 0.562 0 1.2525 0H14.7475C15.438 0 16 0.562 16 1.2525V10.7475C16 11.438 15.438 12 14.7475 12H10.175L5.312 15.8905C5.222 15.963 5.1115 16 5 16ZM1.2525 1C1.1135 1 1 1.1135 1 1.2525V10.7475C1 10.8865 1.1135 11 1.2525 11H5C5.276 11 5.5 11.2235 5.5 11.5V14.4595L9.6875 11.1095C9.7765 11.0385 9.886 11 10 11H14.7475C14.8865 11 15 10.8865 15 10.7475V1.2525C15 1.1135 14.8865 1 14.7475 1H1.2525Z",
    fill: "#8E9AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96875 9C8.24489 9 8.46875 8.77614 8.46875 8.5C8.46875 8.22386 8.24489 8 7.96875 8C7.69261 8 7.46875 8.22386 7.46875 8.5C7.46875 8.77614 7.69261 9 7.96875 9Z",
    fill: "#8E9AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96914 7.49988C7.69314 7.49988 7.46914 7.27588 7.46914 6.99988C7.46914 6.33438 8.05764 5.82788 8.63314 5.41988C8.81214 5.29288 9.00964 4.87238 8.89914 4.52738C8.78964 4.18688 8.35664 3.98388 8.00114 3.98388C8.00114 3.98388 8.00114 3.98388 8.00064 3.98388C7.61064 3.98388 7.12664 4.16538 6.93814 4.67338C6.84164 4.93238 6.55314 5.06338 6.29514 4.96788C6.03564 4.87238 5.90414 4.58438 6.00014 4.32588C6.30264 3.51138 7.08764 2.98438 8.00014 2.98438C8.00014 2.98438 8.00064 2.98438 8.00114 2.98438C8.72314 2.98438 9.59064 3.40937 9.85164 4.22237C10.1036 5.00787 9.71564 5.87937 9.21164 6.23637C8.54164 6.71087 8.46964 6.92888 8.46964 7.00038C8.46914 7.27588 8.24514 7.49988 7.96914 7.49988Z",
    fill: "#8E9AB3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17C18.2066 17 17.9688 16.7761 17.9688 16.5C17.9688 16.2239 18.2066 16 18.5 16C18.7934 16 19.0312 16.2239 19.0312 16.5C19.0312 16.7761 18.7934 17 18.5 17Z",
    fill: "#8E9AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15C18.7932 15 19.0312 14.776 19.0312 14.5V11.5C19.0312 11.224 18.7932 11 18.5 11C18.2068 11 17.9688 11.224 17.9688 11.5V14.5C17.9688 14.776 18.2068 15 18.5 15Z",
    fill: "#8E9AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6875 24C21.7656 24 21.8442 23.984 21.9175 23.9505C22.1019 23.867 22.2188 23.6925 22.2188 23.5V20H25.6692C26.4029 20 27 19.438 27 18.7475V9.2525C27 8.562 26.4029 8 25.6692 8H11.3308C10.5971 8 10 8.562 10 9.2525V18.7475C10 19.438 10.5971 20 11.3308 20H16.1891L21.356 23.8905C21.4516 23.963 21.569 24 21.6875 24ZM25.6692 9C25.8169 9 25.9375 9.1135 25.9375 9.2525V18.7475C25.9375 18.8865 25.8169 19 25.6692 19H21.6875C21.3943 19 21.1562 19.2235 21.1562 19.5V22.4595L16.707 19.1095C16.6125 19.0385 16.4961 19 16.375 19H11.3308C11.1831 19 11.0625 18.8865 11.0625 18.7475V9.2525C11.0625 9.1135 11.1831 9 11.3308 9H25.6692Z",
    fill: "#8E9AB3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 6,
    height: 4,
    rx: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 27 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedHelpIcon);
export default __webpack_public_path__ + "static/media/need-help-icon.76682e229f06b74ab0e42be4026bf336.svg";
export { ForwardRef as ReactComponent };